export default "__VITE_ASSET__Co9kCT5u__"